import React from "react";
import { Navigate } from "react-router-dom";

export default function Backtest() {
  return <Navigate to="/settings?tab=backtest" replace />;
}
